
<div class="container">
    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center p-x-3">
                <i class="icono-arg-tristeza icono-5x text-danger"></i>
                <h1><br>{{error}} !</h1>
                <p class="lead margin-40">Hubo un problema al recuperar los datos del certificado!</p>
            </div>
        </div>
    </section>
</div>